import { render, staticRenderFns } from "./SectionItemNews.vue?vue&type=template&id=c036abee&scoped=true"
import script from "./SectionItemNews.vue?vue&type=script&lang=js"
export * from "./SectionItemNews.vue?vue&type=script&lang=js"
import style0 from "./SectionItemNews.vue?vue&type=style&index=0&id=c036abee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c036abee",
  null
  
)

export default component.exports